"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
var components_1 = require("components");
var description = 'This is how you get Card if you don\'t pass any props. ' +
    'Just a piece of paper. ' +
    'It has an elevation and, when hovered, its shadow spreads a little bit. ';
var code = "import React from 'react';\nimport { Card } from 'jsc-react-ui';\n\nconst CardExample = () => <Card />;";
exports.RawExampleCard = function () { return (React.createElement(common_1.Example, { title: "Raw", description: description, code: code },
    React.createElement(components_1.Card, null))); };
exports.RawExampleCard.displayName = 'RawExampleCard';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentCardPage/RawExampleCard.tsx
// module id = 641
// module chunks = 0